angular.module('combobox', [])
    .service('Combobox', Combo);

Combo.$inject = ['PortalApi', 'Localization', 'Pay'];

function Combo(PortalApi, Localization, Pay) {

    var Combo = {
        comboRegions: {},
        comboRegFullInfo:[],
        selectedRegion: "",     // add that var and hidden input for validate autocomplete directive only after choose value from dropdown
        closeDropdown: false,   //  Close dropdown service after autoSelect from full coincidence
        pageSize: 10,           // vocabulary page size (server side default is also 10)
        hasMore: false,         // last request returned a full page, so next page may exist
        moreLoader: false,      // next page request in progress
        lastRequest: null,      // context of the last get() to repeat it for next pages
        get: function (typed, vocabulary, requestType, dependency) {
            var scope = this;
            Combo.closeDropdown = false;
            Pay.data.comboLoader = true;

            if (Pay.fields[0].type == 'group') {
                for (var i = 0; i < Pay.fields.length; i++) {
                    if (Pay.fields[i].selected) {
                        scope.serviceFields = Pay.fields[i].fields;
                        break;
                    }
                }
            } else {
                scope.serviceFields = Pay.fields;
            }

            var param = null;
            if (dependency && Array.isArray(dependency)) {
                param = dependency
                    .map(function(dep) {
                        var serviceField = scope.serviceFields.find(function(field) {
                            return field.alias === dep;
                        });
                        return serviceField && serviceField.value
                            ? `${serviceField.alias}:${serviceField.value}`
                            : null;
                    })
                    .filter(Boolean);
            }

            var data = {
                query: typed,
                detailSearch: scope.detailSearch,
                vocabulary: vocabulary,
                size: Combo.pageSize,
            };

            if (param) {
                data['param'] = param;
            }

            // remember request context so loadMore() can fetch next pages of the same search
            Combo.lastRequest = data;
            Combo.hasMore = false;
            Combo.moreLoader = false;

            Combo.selectedRegion = "";
            PortalApi.getCombo(data).then(
                function (result) {
                    if (Combo.lastRequest !== data) {
                        // a newer search was started while this one was in flight
                        return;
                    }
                    Combo.hasMore = result.length >= Combo.pageSize;
                    var autoSelectValue = result.find(function (item) {
                        return item.key == data.query;
                    });
                    var areas = [];
                    result.forEach(function (area) {
                        areas.push(area.key);
                    });

                    Combo.comboRegFullInfo = result;
                    Combo.comboRegions[vocabulary] = areas;

                    Pay.data.comboLoader = false;

                    if (autoSelectValue) {
                        Combo.selectCombo(autoSelectValue.key);
                        Combo.closeDropdown = true;
                    }

                    result.map(function (region) {
                        if (region.key == typed) {
                            Combo.selectedRegion = region.key;
                            region.value.map(function (regionFields) {
                                scope.serviceFields.forEach(function (obj) {
                                    if (regionFields[obj.name]) {
                                        obj.value = regionFields[obj.name];
                                    }
                                });
                            });
                        }
                    });
                },
                function () {
                    Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.UNKNOWN_ERROR', 5, true);
                }
            );
        },
        // lazy loading of the next vocabulary page when the dropdown is scrolled to the bottom
        loadMore: function () {
            if (!Combo.hasMore || Combo.moreLoader || !Combo.lastRequest) {
                return;
            }

            var request = Combo.lastRequest;
            var vocabulary = request.vocabulary;
            var loaded = (Combo.comboRegions[vocabulary] || []).length;

            var data = {
                query: request.query,
                detailSearch: request.detailSearch,
                vocabulary: vocabulary,
                size: Combo.pageSize,
                from: loaded
            };

            if (request.param) {
                data['param'] = request.param;
            }

            Combo.moreLoader = true;
            PortalApi.getCombo(data).then(
                function (result) {
                    Combo.moreLoader = false;
                    if (Combo.lastRequest !== request) {
                        // a new search was started while this page was in flight
                        return;
                    }
                    Combo.hasMore = result.length >= Combo.pageSize;
                    Combo.comboRegFullInfo = Combo.comboRegFullInfo.concat(result);

                    // push into the same array so the directive's data binding keeps working
                    var areas = Combo.comboRegions[vocabulary] || [];
                    result.forEach(function (area) {
                        areas.push(area.key);
                    });
                    Combo.comboRegions[vocabulary] = areas;
                },
                function () {
                    Combo.moreLoader = false;
                    Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.UNKNOWN_ERROR', 5, true);
                }
            );
        },
        selectCombo: function(suggestion) {
            var scope = this;
            if (Pay.fields[0].type == 'GROUP') {
                for (var i = 0; i < Pay.fields.length; i++) {
                    if (Pay.fields[i].selected) {
                        scope.serviceFields = Pay.fields[i].fields;
                        break;
                    }
                }
            } else {
                scope.serviceFields = Pay.fields;
            }

            Combo.comboRegFullInfo.map(function (region) {
                if (region.key == suggestion) {
                    Combo.selectedRegion = region.key;
                    region.value.map(function (regionFields) {
                        scope.serviceFields.forEach(function (obj) {
                            if (regionFields[obj.alias]) {
                                obj.value = regionFields[obj.alias]
                            }
                        });
                    });
                }
            });
        }
    };

    return Combo;
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/combobox/combobox.js
 ** module id = 77
 ** module chunks = 1
 **/